import expiredSession from "./expired-session.json";
import login from "./login.json";
import errors from "./errors.json";
import actions from "./actions.json";
import confirmMessages from "./confirm-messages.json";
import labels from "./labels.json";
import noAuth from "./no-auth.json";

export const noAuthPT = {
	...noAuth,
	expiredSession,
	login,
	errors,
	actions,
	confirmMessages,
	labels,
};
